import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { submitForm } from "../../../utils/apiUtils";
import getFileType, { SwitchToggle } from "../../../helper/ImageFormat";
import { Button } from "reactstrap";
import Upload from "../../../Components/upload";
import CodeEditor from "../../../Components/CodeEditor";

const AddHomeBanner = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    title: editData?.title || "",
    description: editData?.description || "",
    url: editData?.url || "",
    desktopImage: editData?.desktopImage || "",
    mobileImage: editData?.mobileImage || "",
    bannerType: editData?.bannerType || "",
    isActive: editData?.isActive ?? true,
    position: editData?.position || editData?.nextPosition
  });
  const [errors, setErrors] = useState({
    title: "",
    description: "",
    url: "",
    desktopImage: "",
    mobileImage: "",
    bannerType: "",
  });
  const editingId = editData?.id;

  const handleChange = (e) => {
    const { name, checked, value } = e.target;
    if (name === "bannerType") {
      setData({
        ...data,
        [name]: value,
      });
    } else if (name === "desktopImage" || name === "mobileImage") {
      setData({ ...data, [name]: null });
    } else if (name === "isActive") {
      setData({ ...data, [name]: checked });
    } else {
      setData({ ...data, [name]: value });
    }

    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  let newErrors = {};

  if (!data.desktopImage) {
    newErrors.desktopImage = "Desktop file is required";
  }

  if (!data.mobileImage) {
    newErrors.mobileImage = "Mobile file is required";
  }

  if (!data.bannerType) {
    newErrors.bannerType = "Banner type is required";
  }


  if (data.desktopImage) {
    const filetype = getFileType(data.desktopImage);
    if (data.bannerType === "Image" && filetype === "video" ) {
      newErrors.desktopImage = "Please upload an image file";
    }

    if (data.bannerType === "Video" && filetype !== "video" ) {
      newErrors.desktopImage = "Please upload a video file";
    }
  }
  if (data.mobileImage) {
    const filetype = getFileType(data.mobileImage);
    if (data.bannerType === "Image" && filetype === "video" ) {
      newErrors.mobileImage = "Please upload an image file";
    }

    if (data.bannerType === "Video" && filetype !== "video" ) {
      newErrors.mobileImage = "Please upload a video file";
    }
  }

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  setLoading(true);

  await submitForm({
    data,
    url: "/homebanner",
    editingId,
    validateFields: [],
    validationErrorsSetter: setErrors,
    navigate: () => navigator("/home-banner"),
  });

  setLoading(false);
};

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   await submitForm({
  //     data,
  //     url: "/homebanner",
  //     editingId,
  //     validateFields: [
  //       { name: "desktopImage", message: "Desktop image is required" },
  //       { name: "bannerType", message: "Banner type is required" },
  //     ],
  //     validationErrorsSetter: setErrors,
  //     navigate: () => navigator("/home-banner"),
  //   });
  //   setLoading(false);
  // };

  const handleUploadChange = (file, fieldName) => {
    setErrors({ ...errors, [fieldName]: "" });
    setData({ ...data, [fieldName]: file });
  };
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5 mx-4">
          <h3 className="page-title">{editData?.id ? "Update" : "Add"} Home Banner</h3>
        </div>
        <div className="col-md-12 grid-margin stretch-card">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">

                   <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername2" className="col-form-label ">
                          SortOrder
                        </label>
                        <input
                          type="number"
                          className={`border border-dark form-control form-control-sm`}
                          id="position"
                          name="position"
                          placeholder="Enter sort order"
                          value={data.position}
                          onChange={handleChange}
                        />
                        {errors.position && (
                          <small className="text-danger">{errors.position}</small>
                        )}
                      </div>
                    </div>


                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="bannerType" className="col-form-label ">
                          Banner Type
                        </label>
                        <select
                          className={`form-control form-control-sm`}
                          id="bannerType"
                          name="bannerType"
                          value={data.bannerType}
                          onChange={handleChange}
                        >
                          <option value="" disabled>
                            Select banner type
                          </option>
                          <option value="Image">Image</option>
                          <option value="Video">Video</option>
                        </select>
                        {errors.bannerType && (
                          <small className="text-danger">{errors.bannerType}</small>
                        )}
                      </div>
                    </div>

                    


                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername2" className="col-form-label ">
                          Title
                        </label>
                        <input
                          type="text"
                          className={`border border-dark form-control form-control-sm ${errors.title ? "is-invalid" : ""}`}
                          id="title"
                          name="title"
                          placeholder="Enter title"
                          value={data.title}
                          onChange={handleChange}
                        />
                        {errors.title && (
                          <small className="text-danger">{errors.title}</small>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername2" className="col-form-label ">
                          Url
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm border border-dark"
                          id="url"
                          name="url"
                          placeholder="Enter url"
                          value={data.url}
                          onChange={handleChange}
                        />
                        {errors.link && <small className="text-danger">{errors.url}</small>}
                      </div>
                    </div>

                   
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="desktopImage" className="col-form-label ">
                          Desktop {data.bannerType} File (1400px X 450px)
                        </label>

                        <Upload
                          label="desktopImage"
                          initialImage={data.desktopImage}
                          onChange={(file) => handleUploadChange(file, "desktopImage")}
                          apiUrl={"uploads?label=homeBanner"}
                        />

                        {errors.desktopImage && (
                          <small className="text-danger">{errors.desktopImage}</small>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="desktopImage" className="col-form-label ">
                          Mobile {data.bannerType} File (540px X 658px)
                        </label>
                        <Upload
                          label="mobileImage"
                          initialImage={data.mobileImage}
                          onChange={(file) => handleUploadChange(file, "mobileImage")}
                          apiUrl={"uploads?label=homeBanner"}
                        />
                        {errors.mobileImage && (
                          <small className="text-danger">{errors.mobileImage}</small>
                        )}
                      </div>
                    </div>



 <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername2" className="col-form-label">
                          Description
                        </label>
                        <CodeEditor
                          value={data.description}
                          style={{ height: "400px" }}
                          onChange={(value) =>
                            handleChange({
                              target: {
                                name: "description",
                                value,
                              },
                            })
                          }
                        />
                        {errors.description && !data?.description?.trim() && (
                          <small className="text-danger">Description is required</small>
                        )}
                      </div>
                    </div>
                    {/* <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername2" className="col-form-label ">
                          Description
                        </label>
                        <textarea
                          type="text"
                          className={`border border-dark form-control form-control-sm ${errors.description ? "is-invalid" : ""}`}
                          id="description"
                          name="description"
                          placeholder="Enter description"
                          cols={5}
                          rows={5}
                          value={data.description}
                          onChange={handleChange}
                        />
                        {errors.description && (
                          <small className="text-danger">{errors.description}</small>
                        )}
                      </div>
                    </div> */}

                    <div className="col-md-12 mt-4 p-2" >
                      <SwitchToggle
                        checked={data.isActive}
                        onChange={(val) => setData((prev) => ({ ...prev, isActive: val }))}
                      />
                    </div>

                  </div>
                  <div
                    className="text-start mt-4"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Button type="submit" color="primary" disabled={loading}>
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          {editData?.id ? "Updating..." : "Submitting..."}
                        </>
                      ) : editData?.id ? (
                        "Update"
                      ) : (
                        "Add"
                      )}
                    </Button>

                    <Link to="/home-banner">
                      <Button color="danger mx-2">Cancel </Button>
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddHomeBanner;
